import { Outlet } from 'react-router-dom';

import { useGlobalDashboardRegistry } from '@features/insights/hooks/use-global-dashboard-registry/use-global-dashboard-registry';
import { InsightsDashboardRegistryProvider } from '@features/insights/insights-registry-provider';
import { InsightsServiceAPIProvider } from '@features/insights/insights-service-api-provider';
import { Loader } from '@packages/components/loader/loader';
import { useHasSubscription } from '@packages/hooks/use-has-subscription/use-has-subscription';
import { InsightsBaseErrorBoundary } from '@packages/insights-widgets/components/insights-error-boundary/insights-base-error-boundary';

import UnavailablePage from '../../pages/unavailable/unavailable.page';

export const Layout = () => {
  const {
    hasSubscription: hasDataExplorer,
    isLoading: dataExplorerIsLoading,
    error,
  } = useHasSubscription('dataExploration');

  const {
    error: dashboardError,
    isLoading: dashboardIsLoading,
    data,
  } = useGlobalDashboardRegistry(hasDataExplorer, dataExplorerIsLoading);

  if (dataExplorerIsLoading || dashboardIsLoading) return <Loader />;

  if (error || dashboardError || !data) {
    return <UnavailablePage />;
  }

  return (
    <InsightsBaseErrorBoundary fallback={<UnavailablePage />}>
      <InsightsDashboardRegistryProvider value={data}>
        <InsightsServiceAPIProvider>
          <Outlet />
        </InsightsServiceAPIProvider>
      </InsightsDashboardRegistryProvider>
    </InsightsBaseErrorBoundary>
  );
};
